// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24Sp5","col":"styles_col__1VPOQ"};